export default "__VITE_ASSET__CRtXZ$8A__"